module.exports = __webpack_public_path__ + "media/images/sports_icons/001-softball-970b89cb5adb5ff58c796d8cdaa0b0ba.png";